import React from "react";
import { formatDate } from "@backpacker/date";
import { AbstractDate, Interval, Range } from "@linkfluence/models/date";
import { Locale } from "@linkfluence/models/locale";
import Tooltip from "./serie";

interface IProps {
  content?: React.ReactNode;
  footer?: React.ReactNode;
  range?: Range;
  locale: Locale;
  subLabel?: string;
  total?: number;
  count: number;
  label: string;
  color?: string;
}

function getDateFormat(date: AbstractDate, interval: Interval, locale: Locale) {
  return formatDate(date, locale, interval === Interval.Hour ? "lll" : "ll");
}

function getFooterFormat({ from, to, interval }: Range, locale: Locale) {
  return `${getDateFormat(from, interval, locale)} — ${getDateFormat(
    to,
    interval,
    locale
  )}`;
}

const TooltipHistogram = ({ range, footer, locale, ...props }: IProps) => (
  <Tooltip
    {...props}
    locale={locale}
    footer={footer ? footer : range ? getFooterFormat(range, locale) : null}
  />
);

export default TooltipHistogram;
